import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';

import { CapturePointSchema, IdentitySignalTypeSchema } from '../signal-type/signal-type';

/**
 * One captured signal, as a **staff** surface reads it (`03-trust-ban-evasion.md`
 * §admin Trust module — "signals captured for a member (types + dates, never raw
 * values)").
 *
 * **What is absent is the contract.** There is no `valueHash`, no `embedding`
 * and no value of any kind, and the schema is `.strict()`, so this is enforced
 * rather than merely intended: a mapper that spread a repository row would fail
 * its own parse instead of quietly serving a peppered hash to a browser. The
 * columns are additionally `hidden` at the repository (N2) — two independent
 * guards, because this is the one shape whose leak would be irreversible.
 *
 * There is no member-facing version of this shape at all. A member who could
 * enumerate their own captured signals could work out which of them the platform
 * matches on, which is the same oracle a blocked registration is written to
 * avoid.
 */
export const IdentitySignalSchema = z
  .object({
    id: UuidSchema,
    userId: UuidSchema,
    signalType: IdentitySignalTypeSchema,
    capturePoint: CapturePointSchema,
    capturedAt: z.iso.datetime(),
  })
  .strict();

export type IdentitySignal = z.infer<typeof IdentitySignalSchema>;
